<template>
  <!-- <v-form> -->
    <v-container id="captchabox">
      <v-row>
        <div id="container3">
          <img v-bind:src="questImage" />
        </div>
      </v-row>
      <v-row>
          <!-- variant="filled" -->
          <v-text-field
            v-model="answerCode"
            :append-icon="input_icon"
            label="Введите текст с картинки"
            type="text"
            :disabled="solved"
            required
            @click:append="runCaptcha"
            :class="{ 'text-green': solved }"
          >
          </v-text-field>
      </v-row>
    </v-container>
</template>
<script>
  export default {
    name: 'OfflineCaptcha',
    components: {},
    props: {
      solved: {
        type: Boolean,
        default: false
      },
      questCode: {
        type: String,
        default: null,
      },
      answerCode: {
        type: String,
        default: null,
      }
      // execute: {
      //   type: Object,
      //   default: this.execute
      // }
    },

    data: () => ({
      questImage: null,
      // questCode: null,
      // answerCode: null,
      // solved: false
    }),
    async created () {
      this.refreshCaptchaQuest()
    },
    computed: {
      input_icon: function () {
        if (this.solved == true) {
          return 'checked'
        }
        if (!this.solved ==true && this.answerCode) {
          return 'send'
        }
        if (!this.solved ==true) {
          return 'sync'
        }
      }
    },
    methods: {
      runCaptcha: function() {
        if (this.solved) {
          return true
        }
        return this.checkCaptcha()
      },
      refreshCaptchaQuest: async function() {
        const result = await this.$api.Account.getOfflineCaptchaQuest();
        this.questCode = result.data.captcha_token;
        this.questImage = result.data.image;
        this.solved = false;
        this.answerCode = null;
      },
      checkCaptcha: async function() {
        if (!this.questCode || !this.answerCode ) {
          this.solved = false;
          this.refreshCaptchaQuest()
          return false;
        }
        else {
          const result = await this.$api.Account.checkOfflineCaptchaQuest(this.questCode, this.answerCode);
          this.solved = result.data.result;
          if (this.solved) {
            return true
          }
        }
        this.refreshCaptchaQuest()
        return false
        
      },
      execute: function() {
        if (this.questCode == null){
          return false
        } 
        if (this.runCaptcha()) {
          let token = [this.questCode, this.answerCode].join(':')
          return token
        }
        return false
        
      }
    }
  }
</script>
<style>
  .text-green input {
      color: rgba(19, 169, 19,  0.42) !important;
    }
  #container3 {
    display: flex;
    width:100%; 
    height:100%; 
    justify-content: center;
    align-items: center;
  }
  #captchabox {
    background-color: rgba(128, 128, 128, 0.12);
    border-radius: 4px;
    padding-bottom: 0px;
  }
</style>